import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import logoBlack from '@/assets/logo-black.svg'
import logoWhite from '@/assets/logo-white.svg'
import { Button } from '@/components/ui/button'
import { useCurrentLang } from '@/shared/i18n/use-current-lang'

export default function NotFoundPage() {
  const { t } = useTranslation('landing')
  const lang = useCurrentLang()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="absolute left-0 top-0 z-10 w-full">
        <div className="flex h-16 w-full items-center px-8">
          <Link
            to="/$lang/app"
            params={{ lang }}
            className="flex items-center gap-1.5"
          >
            <img
              src={logoBlack}
              alt="Laplace"
              className="h-8 w-auto dark:hidden"
            />
            <img
              src={logoWhite}
              alt="Laplace"
              className="hidden h-8 w-auto dark:block"
            />
            <span className="text-xl font-bold text-foreground">Laplace</span>
          </Link>
        </div>
      </header>

      <div className="mx-auto flex min-h-screen max-w-[96rem] flex-col px-6 py-6 sm:px-8 lg:px-12">
        <main className="flex flex-1 items-center justify-center">
          <div className="flex max-w-xl flex-col items-center text-center">
            <div className="text-[9rem] font-medium leading-none tracking-[-0.08em] text-foreground sm:text-[11rem]">
              404
            </div>
            <p className="mt-6 text-xl tracking-[-0.02em] text-foreground sm:text-2xl">
              {t('notFoundShort')}
            </p>
            <p className="mt-3 max-w-md text-sm leading-7 text-muted-foreground sm:text-base">
              {t('notFoundBody')}
            </p>
            <Button
              asChild
              variant="ghost"
              className="mt-8 rounded-full border border-border bg-background px-6 text-base text-foreground hover:bg-accent hover:text-accent-foreground"
            >
              <Link to="/$lang" params={{ lang }}>
                {t('notFoundBackHome')}
              </Link>
            </Button>
          </div>
        </main>
      </div>
    </div>
  )
}
